import { defineNuxtPlugin } from '#imports'
import { getAppContext, getConfig } from '@b2ag/micro-front-tools'
import { initAnalyticsIdf } from '@b2ag/plugin-aladin-gtm'
import { useAuthService } from '@b2ag/auth'
import type { GtmSupportOptions } from '@b2ag/plugin-aladin-gtm'

function getGtmSupportOptions(): GtmSupportOptions {
  const ids: string[] = []
  const { appFrontType } = getAppContext()

  switch (appFrontType) {
    case 'agri':
      if (getConfig('GTM_ID_B2AG')) ids.push(getConfig('GTM_ID_B2AG'))
      if (getConfig('GTM_ID_SPECIFIC')) ids.push(getConfig('GTM_ID_SPECIFIC'))
      break
    case 'tech':
      if (getConfig('GTM_ID')) ids.push(getConfig('GTM_ID'))
      break
    default:
      break
  }

  return {
    id: ids,
    enabled: true,
    defer: true,
    debug: getConfig('ENVIRONMENT_NAME') === 'DEV',
    loadScript: true,
  }
}

export default defineNuxtPlugin({
  name: 'gtm',
  enforce: 'pre',
  dependsOn: ['auth service'],
  hooks: {
    'app:created'() {
      if (window.location.hostname.includes('localhost')) return

      if (getConfig('AXEPTIO_CLIENT_ID') && getConfig('ANALYTICS_API_HOST')) {
        initAnalyticsIdf(getGtmSupportOptions(), useAuthService, getConfig('ANALYTICS_API_HOST'))
      }
    },
  },
})
